import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../apiCallsHelper/authapicalls';


const AdminRoute = ({ children }) => {
    return (
        isAuthenticated() && isAuthenticated().user.role === 25 ? (
            children
        ) : (
            <Navigate
                to= "/signin"
            />
        )
    )
}



export default AdminRoute;